const NoChangeAspectType = {
    NO_CHANGE_ASPECT: 'noChangeAspect',
    CHANGE_ASPECT: 'changeAspect',
    MULTI: 'multi',
};
export default NoChangeAspectType;
